import { render, staticRenderFns } from "./Gocardless.vue?vue&type=template&id=7a4d976b&scoped=true"
import script from "./Gocardless.vue?vue&type=script&lang=js"
export * from "./Gocardless.vue?vue&type=script&lang=js"
import style0 from "./Gocardless.vue?vue&type=style&index=0&id=7a4d976b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4d976b",
  null
  
)

export default component.exports